import {
  Box,
  Checkbox,
  Container,
  FormControlLabel,
  List,
  ListItem,
  ListItemIcon,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import styles from "./AcceptanceStatus.module.scss";
import cn from "classnames";
import CustomInput from "../../../../elements/CustomInput/CustomInput";
import { useForm } from "react-hook-form";
import _sendAPIRequest from "../../../../helpers/api";
import { PortalApiUrls } from "../../../../helpers/api-urls/PortalApiUrls";
import { AlertContext } from "../../../../contexts/AlertProvider";
import { ButtonLoader } from "../../../../elements/CustomLoader/Loader";
import { NavLink } from "react-router-dom";
import DeleteDialog from "../../../../elements/CustomDialog/DeleteDialog";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ScreenLoader from "../../../../elements/CustomScreeenLoader/ScreenLoader";
import {
  dateFormatter,
  dateTimeFormatter,
  formatDate,
} from "../../../../helpers/formatter";
import TermAndConditionModal from "../../../../elements/CustomModal/TermAndConditionModal";

const AcceptanceStatus = ({ bidDetails, type, onActionComplete }) => {
  const { setAlert } = useContext(AlertContext);
  const [isTermandConfitionOpen, setIsTermandConfitionOpen] = useState(false);
  const [loadingAction, setLoadingAction] = useState(null);
  const [loading, setLoading] = useState(false);
  const [participant, setParticipant] = useState({});
  const [screenLoader, setScreenLoader] = useState(true);
  const [isAgreed, setIsAgreed] = useState(
    JSON.parse(localStorage.getItem("isAgreed")) || false,
  );
  const [deleteDetails, setDeleteDetails] = useState({
    open: false,
    title: "",
    message: "",
    action: "",
  });

  // formdata for the invite action
  const formData = new URLSearchParams();
  formData.append("action", deleteDetails.action);
  formData.append(
    "is_sample_invite",
    `${
      bidDetails?.type === "L1" ||
      bidDetails?.participant?.sample?.approval_status === "approved"
        ? false
        : true
    }`,
  );

  // invite action :  accepted / decline
  console.log(bidDetails?.status, "  bid status");
  useEffect(() => {
    const fetchParticipants = async () => {
      try {
        const response = await _sendAPIRequest(
          "GET",
          `${PortalApiUrls.RETRIEVE_INVITED_BID}${bidDetails?.id}/`,
          "",
          true,
        );
        if (response.data.participant) {
          setParticipant(response.data.participant);
          setScreenLoader(false);
        }
      } catch (error) {}
    };
    fetchParticipants();
  }, [bidDetails?.id, deleteDetails.action]);

  const handleAction = async (action) => {
    setLoadingAction(action);
    setLoading(true);
    try {
      const response = await _sendAPIRequest(
        "PUT",
        PortalApiUrls.INVITE_ACTION + `${bidDetails?.id}/`,
        formData,
        true,
      );
      if (response.status === 204) {
        setLoading(false);
        setAlert({
          isVisible: true,
          message:
            action === "accept"
              ? // participant?.status === "accepted" ||
                // (bidDetails?.type === "QCBS" &&
                //   participant?.sample?.invite_status === "accepted")
                "Your bid invitation has been successfully accepted."
              : "Bid invitation has been declined.",
          severity:
            action === "accept"
              ? // participant?.status === "accepted" ||
                // participant?.sample?.invite_status === "accepted"
                "success"
              : "error",
        });
        setDeleteDetails({ open: false, title: "", message: "", action: "" });
        if (onActionComplete) {
          onActionComplete();
        }
      }
    } catch (error) {
      setLoading(false);
      console.log(error.status === 403, " error");
      // if (error.status === 403) {
      //   setAlert({
      //     isVisible: true,
      //     message: error.response.data.detail,
      //     severity: "error",
      //   });
      // }
      error.status === 403 &&
        setAlert({
          isVisible: true,
          message: error.response.data.detail,
          severity: "error",
        });
      console.log(error);
      setDeleteDetails({ open: false, title: "", message: "", action: "" });

      setAlert({
        isVisible: true,
        message:
          bidDetails?.status === "live"
            ? "This bid is now live"
            : bidDetails?.status === "completed"
              ? "This bid has been completed"
              : bidDetails?.status === "closed"
                ? "This bid has been closed"
                : error.status === 403
                  ? error.response?.data?.detail
                  : "error please try again",
        severity: "error",
      });
    }
  };

  // invite action confirmation
  const handleInvitation = (choice) => {
    if (choice) {
      handleAction(deleteDetails.action);
    } else {
      setDeleteDetails({ open: false, title: "", message: "", action: "" });
    }
  };

  if (screenLoader) {
    return <ScreenLoader component={"AcceptanceStatus"} />;
  }

  console.log(bidDetails, " : participant");
  return (
    <>
      <Box
        classname={cn("row", styles["acceptance-box"])}
        sx={{ marginTop: "2rem", marginLeft: "8px" }}
      >
        {bidDetails?.status === "cancelled" ? (
          <Box sx={{ marginBottom: "2rem" }}>
            {/* Heading */}
            <Typography variant="h4" gutterBottom>
              Bid Cancellation Notice
            </Typography>

            {/* Paragraph 2 */}
            <Box sx={{
              mb: 2
            }}>
              <Typography variant="body1">
                We regret to inform you that the bid has been canceled by the
                bid owner. As a result, all activities related to this bid,
                including the submission of product samples and the bidding
                process, have been halted. We understand this may be
                disappointing news, and we sincerely apologize for any
                inconvenience caused. If you have any questions or require
                further assistance, please do not hesitate to contact our
                support team. We appreciate your patience and understanding.
              </Typography>
            </Box>
          </Box>
        ) : bidDetails?.type === "L1" ? (
          participant.status === "pending" ? (
            // PENDING CONTENT
            (<>
              <Box sx={{ marginBottom: "2rem" }}>
                {/* Heading */}
                <Typography variant="h4" gutterBottom>
                  You are invited {bidDetails?.title}
                </Typography>

                {/* Paragraph 2 */}
                <Box sx={{
                  mb: 2
                }}>
                  <Typography variant="body1">
                    We are excited to inform you that you’ve been invited to
                    participate in an upcoming bid on the Bidding karo platform.
                    Your participation is crucial, and we encourage you to
                    review the bid details and key dates outlined below:
                  </Typography>

                  <List>
                    <ListItem>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </ListItemIcon>
                      Live Bid Opening Date :{" "}
                      {dateTimeFormatter(bidDetails?.bid_open_date)}
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </ListItemIcon>
                      Live Bid Closing Date :{" "}
                      {dateTimeFormatter(bidDetails?.bid_close_date)}
                    </ListItem>
                  </List>
                </Box>

                {/* Paragraph 3 */}
                <Box>
                  <Typography variant="body1">
                    To make the most of this opportunity, we recommend staying
                    updated by regularly checking your account for any further
                    instructions or updates. Should you have any questions
                    regarding the bid or the process, feel free to contact us
                    through the platform for assistance.
                  </Typography>
                </Box>
              </Box>
            </>)
          ) : participant.status === "accepted" ||
            participant.status === "awarded" ? (
            // ACCEPTED CONTENT
            (<>
              <Box sx={{ marginBottom: "2rem" }}>
                {/* Heading */}
                <Typography variant="h4" gutterBottom>
                  Thank you for accepting the bid invitation! We’re excited to
                  have you onboard for the bidding process.
                </Typography>

                {/* Paragraph 2 */}
                <Box sx={{
                  mb: 2
                }}>
                  <Typography variant="body1">
                    You will receive an email shortly with instructions on how
                    to proceed. Please ensure you carefully follow the
                    guidelines provided in the email.
                  </Typography>

                  <List>
                    <ListItem>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </ListItemIcon>
                      Live Bid Opening Date :{" "}
                      {dateTimeFormatter(bidDetails?.bid_open_date)}
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </ListItemIcon>
                      Live Bid Closing Date :{" "}
                      {dateTimeFormatter(bidDetails?.bid_close_date)}
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </>)
          ) : participant.status === "declined" ? (
            // DECLINED CONTENT
            (<>
              <Box sx={{ marginBottom: "2rem" }}>
                {/* Heading */}
                <Typography variant="h4" gutterBottom>
                  Acknowledgment of Bid Decline
                </Typography>

                {/* Paragraph 2 */}
                <Box sx={{
                  mb: 2
                }}>
                  <Typography variant="body1">
                    Thank you for informing us about your decision regarding the
                    recent bid invitation on the Bidding karo platform. We
                    understand that circumstances may vary, and we appreciate
                    your prompt response.
                  </Typography>
                </Box>

                {/* Paragraph 3 */}
                <Box>
                  <Typography variant="body1">
                    Should your availability change or if you are interested in
                    future bids, please do not hesitate to reach out. We look
                    forward to potential opportunities to work together down the
                    line.
                  </Typography>
                </Box>
              </Box>
            </>)
          ) : // REVOKED CONTENT
          participant.status === "revoked" ? (
            <>
              <Box sx={{ marginBottom: "2rem" }}>
                {/* Heading */}
                <Typography variant="h4" gutterBottom>
                  Notification of Bid Participation Revocation.
                </Typography>

                {/* Paragraph 2 */}
                <Box sx={{
                  mb: 2
                }}>
                  <Typography variant="body1">
                    We hope this message finds you well. We would like to inform
                    you that, following your acceptance of the bid invitation,
                    your participation in the commercial bid has been revoked by
                    the buyer.
                  </Typography>
                </Box>
                <Box sx={{
                  mb: 2
                }}>
                  <Typography variant="body1">
                    This decision is part of the ongoing evaluation process, and
                    we understand that this news may be unexpected. We encourage
                    you to remain positive, as there will be future
                    opportunities to participate in other bids on the Bidding
                    Kro platform.
                  </Typography>
                </Box>

                {/* Paragraph 3 */}
                <Box>
                  <Typography variant="body1">
                    Thank you for your understanding, and we look forward to
                    your continued engagement with Bidding karo.
                  </Typography>
                </Box>
              </Box>
            </>
          ) : (
            // DEFAULT CONTENT
            (<>
              <Box sx={{ marginBottom: "2rem" }}>
                {/* Heading */}
                <Typography variant="h4" gutterBottom>
                  You are invited {bidDetails?.title}
                </Typography>

                {/* Paragraph 2 */}
                <Box sx={{
                  mb: 2
                }}>
                  <Typography variant="body1">
                    We are excited to inform you that you’ve been invited to
                    participate in an upcoming bid on the Bidding karo platform.
                    Your participation is crucial, and we encourage you to
                    review the bid details and key dates outlined below:
                  </Typography>

                  <List>
                    <ListItem>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </ListItemIcon>
                      Bid Opening Date :{" "}
                      {dateTimeFormatter(bidDetails?.bid_open_date)}
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </ListItemIcon>
                      Bid Closing Date :{" "}
                      {dateTimeFormatter(bidDetails?.bid_close_date)}
                    </ListItem>
                  </List>
                  <Typography variant="body1">
                    Your sample will be reviewed by the buyer. Once it is
                    approved, you will be notified and can proceed with the
                    bidding process.
                  </Typography>
                </Box>

                {/* Paragraph 3 */}
                <Box>
                  <Typography variant="body1">
                    To make the most of this opportunity, we recommend staying
                    updated by regularly checking your account for any further
                    instructions or updates. Should you have any questions
                    regarding the bid or the process, feel free to contact us
                    through the platform for assistance.
                  </Typography>
                </Box>
              </Box>
            </>)
          )
        ) : participant?.sample?.invite_status === "pending" ? (
          // SAMPLE INVITE PENDING CONTENT
          (<>
            <Box sx={{ marginBottom: "2rem" }}>
              {/* Heading */}
              <Typography variant="h4" gutterBottom>
                Invitation for Quality-Based Selection Bid
              </Typography>
              {console.log(bidDetails, "; bidDetails")}
              {/* Paragraph 2 */}
              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  We are excited to invite you to participate in a Quality-Based
                  Selection bid on our platform, Bidding karo. This process
                  requires suppliers to submit samples for evaluation, which
                  will determine your eligibility to proceed with live bidding.
                </Typography>

                <>
                  <Typography variant="body1">
                    ease take a moment to review the bid details and submit your
                    materials for the quality check. If you need any assistance,
                    feel free to reach out to our support team.
                  </Typography>
                  <List>
                    <ListItem>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </ListItemIcon>
                      Sample Receiving Opening date :{" "}
                      {formatDate(bidDetails?.sample_receive_start_date)}
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </ListItemIcon>
                      Sample Receiving Closing date :{" "}
                      {formatDate(bidDetails?.sample_receive_end_date)}
                    </ListItem>
                  </List>
                  <Typography variant="body1">
                    Your sample will be reviewed by the buyer. Once it is
                    approved, you will be notified and can proceed with the
                    bidding process.
                  </Typography>
                </>
              </Box>

              {/* Paragraph 3 */}
              <Box>
                <Typography variant="body1">
                  We appreciate your patience and cooperation.
                </Typography>
              </Box>
            </Box>
          </>)
        ) : participant?.sample?.invite_status === "accepted" &&
          participant?.sample?.approval_status === "pending" ? (
          // SAMPLE INVITE ACCEPTED CONTENT
          (<>
            <Box sx={{ marginBottom: "2rem" }}>
              {/* Heading */}
              <Typography variant="h4" gutterBottom>
                Acceptance Confirmation for Quality-Based Selection Bid
              </Typography>

              {/* Paragraph 2 */}
              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  Thank you for accepting the invitation to participate in the
                  Quality-Based Selection bid on our platform, Bidding karo. We
                  are pleased to have you on board for this important process.
                </Typography>

                <>
                  <Typography variant="body1">
                    As a reminder, please ensure that your samples are submitted
                    within the following timeline:
                  </Typography>
                  <List>
                    <ListItem>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </ListItemIcon>
                      Sample Receiving Opening date :{" "}
                      {formatDate(bidDetails?.sample_receive_start_date)}
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </ListItemIcon>
                      Sample Receiving Closing date :{" "}
                      {formatDate(bidDetails?.sample_receive_end_date)}
                    </ListItem>
                  </List>
                  <Typography variant="body1">
                    Once we receive your samples, our evaluation team will
                    assess them based on the specified criteria. Should you have
                    any questions or require further assistance during this
                    process, do not hesitate to contact us.
                  </Typography>
                </>
              </Box>

              {/* Paragraph 3 */}
              <Box>
                <Typography variant="body1">
                  We appreciate your patience and cooperation.
                </Typography>
              </Box>
            </Box>
          </>)
        ) : participant?.sample?.invite_status === "declined" ? (
          // SAMPLE INVITE DECLINED CONTENT
          (<>
            <Box sx={{ marginBottom: "2rem" }}>
              {/* Heading */}
              <Typography variant="h4" gutterBottom>
                Bid Invitation Declined
              </Typography>

              {/* Paragraph 2 */}
              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  We have received your decision to decline the bid invitation.
                  As you have opted out of this bidding opportunity, no further
                  action is required on your part.
                </Typography>

                <>
                  <Typography variant="body1">
                    Thank you for considering this bid, and we respect your
                    decision. We look forward to collaborating on future
                    opportunities.
                  </Typography>
                </>
              </Box>

              {/* Paragraph 3 */}
              <Box>
                <Typography variant="body1">
                  We appreciate your patience and cooperation.
                </Typography>
              </Box>
            </Box>
          </>)
        ) : participant?.sample?.approval_status === "rejected" &&
          participant?.status === "pending" &&
          bidDetails?.bid_open_date === null ? (
          // SAMPLE REJECTED BY BUYER
          (<>
            <Box sx={{ marginBottom: "2rem" }}>
              {/* Heading */}
              <Typography variant="h4" gutterBottom>
                Update on Your Sample Submission
              </Typography>

              {/* Paragraph 1 */}
              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  Thank you for submitting your sample for the Quality-Based
                  Selection bid. After careful review, we regret to inform you
                  that the buyer has decided not to approve the submitted sample
                  at this stage.
                </Typography>

                <Typography variant="body1">
                  As a result, you will not be invited to participate in the
                  live bidding process for this bid.
                </Typography>
              </Box>

              {/* Paragraph 2 */}
              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  We understand that this may be disappointing. Please note that
                  this decision is based on the buyer’s evaluation criteria and
                  specific requirements for this bid.
                </Typography>
              </Box>

              {/* Paragraph 3 */}
              <Box>
                <Typography variant="body1">
                  We encourage you to continue participating in future bids and
                  wish you the very best in your upcoming opportunities.
                </Typography>
              </Box>
            </Box>
          </>)
        ) : participant?.sample?.approval_status === "rejected" &&
          participant?.status === "pending" &&
          bidDetails?.bid_open_date !== null ? (
          // SAMPLE REJECTED BY BUYER BUT THE LIVE BID DATED DECLARED
          (<>
            <Box sx={{ marginBottom: "2rem" }}>
              {/* Heading */}
              <Typography variant="h4" gutterBottom>
                Update on Your Sample Submission
              </Typography>

              {/* Paragraph 1 */}
              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  Thank you for submitting your sample for the Quality-Based
                  Selection bid. After careful review, we regret to inform you
                  that the buyer has decided not to approve the submitted sample
                  at this stage.
                </Typography>

                <Typography variant="body1">
                  As a result, you will not be invited to participate in the
                  live bidding process for this bid.
                </Typography>
              </Box>

              {/* Paragraph 2 */}
              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  We understand that this may be disappointing. Please note that
                  this decision is based on the buyer’s evaluation criteria and
                  specific requirements for this bid.
                </Typography>
              </Box>

              {/* Paragraph 3 */}
              <Box>
                <Typography variant="body1">
                  We encourage you to continue participating in future bids and
                  wish you the very best in your upcoming opportunities.
                </Typography>
              </Box>
            </Box>
          </>)
        ) : participant?.sample?.approval_status === "approved" &&
          participant?.status === "pending" &&
          bidDetails?.bid_open_date === null ? (
          // SAMPLE APPROVAL BUT WAIT FOR THE LIVE BID INVITE
          (<>
            <Box sx={{ marginBottom: "2rem" }}>
              {/* Heading */}
              <Typography variant="h4" gutterBottom>
                Sample Approved Successfully
              </Typography>

              {/* Paragraph 1 */}
              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  Thank you for submitting your sample for the Quality-Based
                  Selection bid. We are pleased to inform you that the buyer has
                  approved your submitted sample.
                </Typography>

                <Typography variant="body1">
                  You are now eligible to participate in the live bidding
                  process for this bid.
                </Typography>
              </Box>

              {/* Paragraph 2 */}
              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  Please note that the live bidding dates and details will be
                  shared once the buyer schedules the live bid.
                </Typography>
              </Box>

              {/* Paragraph 3 */}
              <Box>
                <Typography variant="body1">
                  We appreciate your participation and wish you the best of luck
                  in the upcoming live bidding.
                </Typography>
              </Box>
            </Box>
          </>)
        ) : participant?.sample?.approval_status === "approved" &&
          participant?.status === "pending" &&
          bidDetails?.bid_open_date !== null ? (
          // SAMPLE APPROVAL WITH COMMERCIAL BID INVITE PENDING CONTENT
          (<>
            <Box sx={{ marginBottom: "2rem" }}>
              {/* Heading */}
              <Typography variant="h4" gutterBottom>
                Congratulations! Your Sample is Approved – Live Bid Invitation
                Awaits
              </Typography>

              {/* Paragraph 2 */}
              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  We are pleased to inform you that your sample submitted for
                  the Quality-Based Selection bid has been reviewed and approved
                  by the buyer. Congratulations on this achievement!
                </Typography>

                <>
                  <Typography variant="body1">
                    As a result, you are now invited to participate in the live
                    bidding process. Here are the details for the live bid:
                  </Typography>
                  <List>
                    <ListItem>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </ListItemIcon>
                      Live Bid Opening date :{" "}
                      {dateTimeFormatter(bidDetails?.bid_open_date)}
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </ListItemIcon>
                      Live Bid Closing date :{" "}
                      {dateTimeFormatter(bidDetails?.bid_close_date)}
                    </ListItem>
                  </List>
                  <Typography variant="body1">
                    Please make sure to prepare for the live bid and have any
                    necessary documentation ready for submission. If you have
                    any questions or need further assistance, feel free to reach
                    out to us.
                  </Typography>
                </>
              </Box>

              {/* Paragraph 3 */}
              <Box>
                <Typography variant="body1">
                  We look forward to your participation in the live bid and wish
                  you the best of luck!
                </Typography>
              </Box>
            </Box>
          </>)
        ) : participant.sample?.approval_status === "approved" &&
          participant.status === "accepted" ? (
          // SAMPLE  APPROVAL WITH COMMERCIAL BID INVITE ACCEPTED CONTENT
          (<>
            <Box sx={{ marginBottom: "2rem" }}>
              {/* Heading */}
              <Typography variant="h4" gutterBottom>
                Thank You for Accepting the Bid Invitation!
              </Typography>

              {/* Paragraph 2 */}
              <Box sx={{
                mb: 2
              }}>
                <>
                  <Typography variant="body1">
                    You will receive an email shortly with instructions on how
                    to send a sample of your product to the buyer. Please ensure
                    you follow the guidelines provided in the email.
                  </Typography>
                  <List>
                    <ListItem>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </ListItemIcon>
                      Live Bid Opening date :{" "}
                      {dateTimeFormatter(bidDetails?.bid_open_date)}
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </ListItemIcon>
                      Live Bid Closing date :{" "}
                      {dateTimeFormatter(bidDetails?.bid_close_date)}
                    </ListItem>
                  </List>
                </>
              </Box>

              {/* Paragraph 3 */}
              <Box>
                <Typography variant="body1">
                  We appreciate your patience and cooperation.
                </Typography>
              </Box>
            </Box>
          </>)
        ) : participant?.sample?.approval_status === "approved" &&
          participant?.status === "declined" ? (
          // SAMPLE  APPROVAL WITH COMMERCIAL BID INVITE DECLINED CONTENT
          (<>
            <Box sx={{ marginBottom: "2rem" }}>
              {/* Heading */}
              <Typography variant="h4" gutterBottom>
                Live Bid Invitation Declined
              </Typography>

              {/* Paragraph */}
              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  Your product sample was successfully reviewed and approved by
                  the buyer. However, you have chosen to decline the invitation
                  to participate in the live bidding phase for this bid.
                </Typography>
              </Box>

              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  As a result, you will not be participating in the live bidding
                  process for this opportunity. No further action is required
                  from your side at this stage.
                </Typography>
              </Box>

              {/* Closing */}
              <Box>
                <Typography variant="body1">
                  We appreciate the time and effort you invested during the
                  sample evaluation phase and look forward to your participation
                  in future bidding opportunities.
                </Typography>
              </Box>
            </Box>
          </>)
        ) : participant?.sample?.approval_status === "approved" &&
          participant?.status === "revoked" ? (
          // SAMPLE APPROVED BUT REVOKED FROM THE LIVE BID CONTENT
          (<>
            <Box sx={{ marginBottom: "2rem" }}>
              {/* Heading */}
              <Typography variant="h4" gutterBottom>
                Notification of Bid Participation Revocation.
              </Typography>

              {/* Paragraph 2 */}
              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  We hope this message finds you well. We would like to inform
                  you that, following your acceptance of the bid invitation,
                  your participation in the commercial bid has been revoked by
                  the buyer.
                </Typography>
              </Box>
              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  This decision is part of the ongoing evaluation process, and
                  we understand that this news may be unexpected. We encourage
                  you to remain positive, as there will be future opportunities
                  to participate in other bids on the Bidding karo platform.
                </Typography>
              </Box>

              {/* Paragraph 3 */}
              <Box>
                <Typography variant="body1">
                  Thank you for your understanding, and we look forward to your
                  continued engagement with Bidding karo.
                </Typography>
              </Box>
            </Box>
          </>)
        ) : participant?.sample?.approval_status === "approved" &&
          participant?.status === "participated" ? (
          // BID PARTICIPATION
          (<>
            <Box sx={{ marginBottom: "2rem" }}>
              {/* Heading */}
              <Typography variant="h4" gutterBottom>
                Notification of Bid Participation
              </Typography>

              {/* Paragraph 1 */}
              <Box sx={{
                mb: 2
              }}>
                <Typography variant="body1">
                  We are pleased to inform you that your participation in the
                  commercial bid has been successfully recorded. Thank you for
                  accepting the bid invitation on the Bidding karo platform.
                </Typography>
              </Box>

              {/* Paragraph 3 */}
              <Box>
                <Typography variant="body1">
                  Thank you for your continued trust in Bidding karo. We look
                  forward to sharing the results with you soon. Stay tuned for
                  further updates.
                </Typography>
              </Box>
            </Box>
          </>)
        ) : (
          // DEFAULT CONTENT
          (<>
            <Box sx={{ marginBottom: "2rem" }}>
              {/* Heading */}
              <Typography variant="h4" gutterBottom>
                Thank You for Accepting the Bid Invitation!
              </Typography>

              {/* Paragraph 2 */}
              <Box sx={{
                mb: 2
              }}>
                {bidDetails?.type === "L1" ? (
                  <Typography variant="body1">
                    You will receive an email shortly with instructions on how
                    to proceed with the bidding process. Please ensure you
                    follow the guidelines provided in the email.
                  </Typography>
                ) : (
                  <>
                    <Typography variant="body1">
                      You will receive an email shortly with instructions on how
                      to send a sample of your product to the buyer. Please
                      ensure you follow the guidelines provided in the email.
                    </Typography>
                    <List>
                      <ListItem>
                        <ListItemIcon>
                          <FiberManualRecordIcon
                            style={{ fontSize: "small" }}
                          />
                        </ListItemIcon>
                        Sample Receiving Opening date :{" "}
                        {formatDate(bidDetails?.sample_receive_start_date)}
                      </ListItem>
                      <ListItem>
                        <ListItemIcon>
                          <FiberManualRecordIcon
                            style={{ fontSize: "small" }}
                          />
                        </ListItemIcon>
                        Sample Receiving Closing date :{" "}
                        {formatDate(bidDetails?.sample_receive_end_date)}
                      </ListItem>
                    </List>
                    <Typography variant="body1">
                      Your sample will be reviewed by the buyer. Once it is
                      approved, you will be notified and can proceed with the
                      bidding process.
                    </Typography>
                  </>
                )}
              </Box>

              {/* Paragraph 3 */}
              <Box>
                <Typography variant="body1">
                  We appreciate your patience and cooperation.
                </Typography>
              </Box>
            </Box>
          </>)
        )}
        {bidDetails?.status !== "cancelled" &&
          type === "invited" &&
          participant?.status === "pending" &&
          (bidDetails?.type === "L1" ||
            (bidDetails?.type === "QCBS" &&
              participant?.sample &&
              // 🟢 Sample invite pending
              (participant?.sample?.invite_status === "pending" ||
                // 🟢 Live bid invite stage (sample approved already)
                (participant?.sample?.invite_status === "accepted" &&
                  participant?.sample?.approval_status === "approved" &&
                  bidDetails?.bid_open_date !== null)))) && (
            <Box sx={{ marginBottom: "10px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAgreed}
                    onChange={(e) => setIsAgreed(e.target.checked)}
                    sx={{
                      color: "#1976d2",
                      "&.Mui-checked": {
                        color: "#1976d2",
                      },
                    }}
                  />
                }
                label={
                  <Typography variant="body2">
                    I agree to the{" "}
                    <span
                      style={{ color: "#1976d2", cursor: "pointer" }}
                      onClick={(e) => {
                        e.preventDefault();
                        setIsTermandConfitionOpen(true);
                      }}
                    >
                      terms and conditions
                    </span>
                  </Typography>
                }
              />
            </Box>
          )}

        {bidDetails?.status !== "cancelled" && type === "invited" && (
          <Box className={styles["btn-contanier"]}>
            {participant?.status === "accepted" ||
            participant?.status === "declined" ||
            (bidDetails?.type === "QCBS" &&
              ((participant?.sample?.invite_status === "accepted" &&
                participant?.sample?.approval_status === "pending") ||
                participant?.sample?.invite_status === "declined")) ? (
              <button
                type="button"
                className={`btn button ${
                  participant?.status === "accepted"
                    ? "approve"
                    : participant?.status === "revoked"
                      ? "reject"
                      : bidDetails.type === "QCBS" &&
                          participant?.sample?.invite_status === "accepted"
                        ? "approve"
                        : "reject"
                }`}
                disabled={true}
              >
                {bidDetails?.type === "L1"
                  ? participant?.status
                  : bidDetails?.type === "QCBS" &&
                      participant?.sample.approval_status === "approved" &&
                      bidDetails?.bid_open_date !== null
                    ? participant.status
                    : bidDetails?.type === "QCBS"
                      ? participant?.sample?.invite_status
                      : participant?.status}
              </button>
            ) : (bidDetails?.type === "L1" &&
                participant?.status === "pending") ||
              (bidDetails?.type === "QCBS" &&
                participant?.sample?.invite_status === "pending") ||
              (bidDetails?.type === "QCBS" &&
                participant?.sample?.approval_status === "approved" &&
                bidDetails?.bid_open_date !== null &&
                participant?.status === "pending") ? (
              <>
                {loading && loadingAction === "decline" ? (
                  <ButtonLoader size={60} />
                ) : (
                  <button
                    type="button"
                    className="btn button reject"
                    onClick={() =>
                      setDeleteDetails({
                        open: true,
                        title: "Decline Bid Invite",
                        message: `Are you sure you want to decline this invite bid? This action cannot be undone.`,
                        action: "decline",
                      })
                    }
                  >
                    Decline
                  </button>
                )}

                {loading && loadingAction === "accept" ? (
                  <ButtonLoader size={60} />
                ) : (
                  <Tooltip
                    title={
                      !isAgreed
                        ? "Please agree to the terms and conditions first"
                        : ""
                    }
                    arrow
                  >
                    <span>
                      <button
                        type="button"
                        className="btn button approve"
                        disabled={!isAgreed}
                        onClick={() =>
                          setDeleteDetails({
                            open: true,
                            title: "Accept Bid Invite",
                            message: `Are you sure you want to accept this invite bid?`,
                            action: "accept",
                          })
                        }
                      >
                        Accept
                      </button>
                    </span>
                  </Tooltip>
                )}
              </>
            ) : null}

            {deleteDetails?.open && (
              <DeleteDialog
                title={deleteDetails.title}
                message={deleteDetails.message}
                handleClick={handleInvitation}
              />
            )}
          </Box>
        )}

        {isTermandConfitionOpen && (
          <TermAndConditionModal
            isTermandConfitionOpen={isTermandConfitionOpen}
            setIsTermandConfitionOpen={setIsTermandConfitionOpen}
            setIsAgreed={setIsAgreed}
            IsAgreed={isAgreed}
          />
        )}
      </Box>
    </>
  );
};

export default AcceptanceStatus;
